// Instead of this, considering phx-trigger-action
// Add a dropdown to the screenshot

export const Arcade = {
  mounted() {
    this.csrfToken = document.querySelector("meta[name=csrf-token]").getAttribute("content");
    this.updateArcadePath = this.el.dataset.updateArcadePath;
    this.refreshOnChange = this.el.dataset.refreshOnChange == "true";

    this.arcade_data = JSON.parse(this.el.dataset.arcade);

    document.querySelector("#on-counter-date").addEventListener("click", (ev) => {
      ev.preventDefault();
      this.updateArcade("validate_ocd?", !this.arcade_data["validate_ocd?"]);
    });
  },

  async updateArcade(key, value) {
    const resp = await fetch(this.updateArcadePath, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken
      },
      body: JSON.stringify({ var: key, val: value })
    });

    const resp_json = await resp.json();

    this.pushEventTo(this.el, "update-arcade", resp_json);
    // if (this.refreshOnChange) window.location = window.location.href;
    window.location = window.location.href;
  },

  updated() {
    this.arcade_data = JSON.parse(this.el.dataset.arcade);
  }
};
